module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTgxIiBoZWlnaHQ9IjE0MzIiPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjMjcyNzI3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxIDEpIj48Y2lyY2xlIGN4PSI3MTUiIGN5PSI3OTQiIHI9IjMxNyIgb3BhY2l0eT0iLjQxMyIvPjxjaXJjbGUgY3g9IjcxNS41IiBjeT0iNzk0LjUiIHI9IjQxNy41IiBvcGFjaXR5PSIuMjM5Ii8+PGNpcmNsZSBjeD0iNzE1IiBjeT0iNzk1IiByPSI1NTciIG9wYWNpdHk9Ii4xMjMiLz48Y2lyY2xlIGN4PSI3MTUiIGN5PSI3MTUiIHI9IjcxNSIgb3BhY2l0eT0iLjA2NSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mercedes-circles.svg
// module id = 6rwV
// module chunks = 0